export enum DocumentTypeCode {
  CC = 'CC',
  TI = 'TI',
  TE = 'TE',
  CE = 'CE',
  NIT = 'NIT',
  PAS = 'PAS',
  NIUP = 'NIUP',
  PTT = 'PTT',
  PEP = 'PEP'
}

export const DOCUMENT_TYPE_MAP: Record<DocumentTypeCode, string> = {
  [DocumentTypeCode.CC]: '13-Cédula de Ciudadanía',
  [DocumentTypeCode.TI]: '12-Tarjeta de identidad',
  [DocumentTypeCode.TE]: '21-Tarjeta de Extranjería',
  [DocumentTypeCode.CE]: '22-Cédula de Extranjería',
  [DocumentTypeCode.NIT]: '31-Número de Identificación Tributaria',
  [DocumentTypeCode.PAS]: '41-Pasaporte',
  [DocumentTypeCode.NIUP]: '91-Número Único de Identificación Personal',
  [DocumentTypeCode.PTT]: '48-Permiso de protección temporal',
  [DocumentTypeCode.PEP]: '47-Permiso Especial de Permanencia'
};

export function mapDocumentType(code?: string): string {
  if (!code) return '';

  return DOCUMENT_TYPE_MAP[code] ?? code;
}
